<template>
  <div class="tabs-wap">
    <div class="tabs-list header" id="tabs">
      <label class="tabs-item" v-for="item in tabs" :key="item.key" :class="item.key === tabKey ? 'active' : ''" @click="tabsClick(item.key)">
        {{item.label}}
      </label>
    </div>
    <div style="min-height:80vh;" id="tabConEle">
      <Consituent v-if="tabKey === 'constituent'" :total="totalCount"/> 
      <Fund v-if="tabKey === 'fund'"/>
    </div>
  </div>
</template>

<script>
import Consituent from './constituent'
import Fund from './fund'

export default {
  components: {Consituent,Fund},
  props: {
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      scrollTop: 0,
      tabKey: 'constituent',
      tabs: [{
        key: 'constituent',
        label: '成分股'
      },{
        key: 'fund',
        label: '资金'
      }]
    }
  },
  methods: {
    getElementTop(element) {
      var actualTop = element.offsetTop
      var current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    tabsClick(key) {
      let top = this.getElementTop(document.querySelector('#tabConEle'))
      window.scrollTo(0, top-100)
      this.tabKey = key
    }
  }
}
</script>

<style lang="stylus" scoped>
.tabs-wap
  margin-top 0.06rem
  height auto
  background #fff
  // 0px 7px
  .header
    position -webkit-sticky
    position sticky
    top 1.11rem
    background #fff
    z-index 99
  .tabs-list
    height 34px
    border-bottom 1px solid #edeff3
    display flex
    justify-content space-around
    // padding 0 7px
    .tabs-item
      font-size 15px
      // margin 5px 0 0 0
      // padding 7px 5px
      // margin-bottom 7px
      // margin-right 12px
      font-weight 400
      height 34px
      line-height 34px
      &.active
        border-bottom 2px solid #f43737
        color #f43737
</style>